var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"w-full mt-28 px-8"},[_c('Mybookings')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }